module.exports = __webpack_public_path__ + "static/media/Asset 8.2@3x.c3e27c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 8.2@3x.png
// module id = 2402
// module chunks = 0